interface ShouldValidateAccountNumberOptions {
  accountNumber: number | null
  automaticAccountNumber: number | undefined
  isManualEntryEnabled: boolean
}

interface RequiredAccountNumberValidationOptions extends ShouldValidateAccountNumberOptions {
  accountNumber: number
}

export const shouldValidateAccountNumber = (
  options: ShouldValidateAccountNumberOptions,
): options is RequiredAccountNumberValidationOptions => {
  const { accountNumber, automaticAccountNumber, isManualEntryEnabled } = options

  return isManualEntryEnabled && accountNumber !== null && accountNumber !== automaticAccountNumber
}
